//Add preloader
export function addPreloader() {
    if ($('#preloader').length != 0) {
        $('#preloader').remove();
    }
    $(`<div class='preloader' id='preloader'></div>`).appendTo('body')
}
 //Remove preloader
export function removePreloader() {
  if ($('#preloader').length != 0) {
      $('#preloader').fadeOut();
  }
}